import React from 'react';

const Hero = ({ scrollToSection, isDarkMode }) => {
  const imageSrc = isDarkMode 
    ? "/WhatsApp%20Image%202026-01-20%20at%2012.09.05%20PM.jpeg" 
    : "/WhatsApp%20Image%202026-01-13%20at%2010.57.17%20PM.jpeg";

  const heroHighlights = [
    "Scalable ML pipelines & LLM-powered applications",
    "NLP, RAG systems & backend ML deployment",
    "Python, FastAPI, Docker & modern AI tooling"
  ];

 
    
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-intro">Hey there, I'm</p>
          <h1>Suhen M G</h1>
          <h2>Machine Learning Engineer | AI Systems Builder | LLM & NLP Applications</h2>
          <div className="hero-description">
            <p>Building production-grade AI systems with scalable ML pipelines and LLM-powered applications</p>
            <div className="highlights">
              <ul>
              {heroHighlights.map((highlight, idx) => (
                <li key={idx} className="highlight-badge"> {highlight}</li>
              ))}
              </ul>

            </div>
          
          </div>
          <button className="cta-button" onClick={() => scrollToSection('contact')}>Get In Touch</button>
        </div>
        
        <div className="hero-image">
          <div className="image-wrapper">
            {/* Large Blob Background */}
            <div className="blob-large"></div>
            
            {/* Profile Image Container with Ring */}
            <div className="profile-wrapper">
              <div className="profile-ring"></div>
              <div className="profile-image-container">
                <img
                  src={imageSrc}
                  alt="Suhen M G"
                  className="profile-image"
                />
              </div>
              {/* Animated Border Accent */}
              <div className="border-animator"></div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hero-content {
          animation: slideInLeft 1s ease-out;
        }

        .hero-intro {
          animation: fadeInDown 0.8s ease-out;
        }

        .hero-content h1 {
          animation: fadeInUp 1s ease-out 0.2s both;
          font-size: 4rem;
        }

        .hero-content h2 {
          animation: fadeInUp 1s ease-out 0.4s both;
          font-size: 1.5rem;
        }

        .highlights {
          gap: 0.75rem;
          margin: 1rem 0;
        }

        .highlight-badge {
          font-size: 0.95rem;
          color: #00fff7;
          font-weight: 500;
          opacity: 0.9;
          transition: opacity 0.3s ease, transform 0.3s ease;
          animation: fadeInSlideRight 0.6s ease-out both;
        }

        .highlight-badge:nth-child(1) {
          animation-delay: 0.6s;
        }

        .highlight-badge:nth-child(2) {
          animation-delay: 0.8s;
        }

        .highlight-badge:nth-child(3) {
          animation-delay: 1s;
        }

        .highlight-badge:hover {
          opacity: 1;
          transform: translateX(8px);
          color: #00d4ff;
          text-shadow: 0 0 10px rgba(0, 255, 247, 0.5);
        }

        .currently-working {
          background: rgba(0, 255, 247, 0.05);
          padding: 1.25rem;
          border-radius: 0.75rem;
          margin: 1.5rem 0;
          border-left: 3px solid #00fff7;
          animation: slideInUp 0.8s ease-out 1.2s both;
          backdrop-filter: blur(10px);
        }

        .working-title {
          font-size: 0.9rem;
          font-weight: 600;
          color: #00fff7;
          margin: 0 0 0.75rem 0;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          animation: pulse-text 2s ease-in-out infinite;
        }

        .currently-working ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .currently-working li {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.85);
          margin: 0.5rem 0;
          padding-left: 1.5rem;
          position: relative;
          animation: fadeInSlideRight 0.6s ease-out both;
        }

        .currently-working li:nth-child(1) {
          animation-delay: 1.3s;
        }

        .currently-working li:nth-child(2) {
          animation-delay: 1.4s;
        }

        .currently-working li:nth-child(3) {
          animation-delay: 1.5s;
        }

        .currently-working li:before {
          content: "→";
          position: absolute;
          left: 0;
          color: #00fff7;
          font-weight: bold;
          animation: slideArrow 1.5s ease-in-out infinite;
        }

        .cta-button {
          animation: fadeInUp 1s ease-out 1.6s both;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .cta-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: rgba(0, 255, 247, 0.2);
          transition: left 0.5s ease;
          z-index: -1;
        }

        .cta-button:hover::before {
          left: 100%;
        }

        .image-wrapper {
          position: relative;
          width: 500px;
          height: 600px;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: slideInRight 1s ease-out;
        }

        .blob-large {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 450px;
          height: 380px;
          background: linear-gradient(180deg, #00fff7 0%, #00d4ff 50%, #0099ffa2 100%);
          border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
          filter: blur(1px);
          z-index: 1;
          animation: blobAnimate 8s ease-in-out infinite;
        }

        .profile-wrapper {
          position: relative;
          z-index: 2;
          margin-top: 180px;
          animation: floatUp 6s ease-in-out infinite;
        }

        .profile-ring {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 420px;
          height: 420px;
          border: 3px solid #00fff7;
          border-radius: 50%;
          z-index: 1;
          animation: rotateSlow 20s linear infinite;
          box-shadow: 0 0 30px rgba(0, 255, 247, 0.3);
        }

        .profile-image-container {
          position: relative;
          width: 350px;
          height: 350px;
          overflow: hidden;
          border-radius: 50%;
          border: 5px solid #00fff7;
          box-shadow: 0 0 60px rgba(0, 255, 247, 0.6), 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          z-index: 2;
          animation: glowPulse 3s ease-in-out infinite;
        }

        .border-animator {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 365px;
          height: 365px;
          border-radius: 50%;
          border: 2px solid transparent;
          border-top-color: #00fff7;
          border-right-color: #00d4ff;
          z-index: 0;
          animation: spinBorder 8s linear infinite;
          opacity: 0.5;
        }

        .profile-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1);
          transition: transform 0.5s ease;
          animation: imageZoomIn 1.2s ease-out;
        }

        .profile-image:hover {
          transform: scale(1.08);
          filter: brightness(1.1);
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInSlideRight {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes pulse-text {
          0%, 100% {
            color: #00fff7;
            text-shadow: 0 0 5px rgba(0, 255, 247, 0.3);
          }
          50% {
            color: #00d4ff;
            text-shadow: 0 0 15px rgba(0, 215, 255, 0.6);
          }
        }

        @keyframes slideArrow {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(4px);
          }
        }

        @keyframes blobAnimate {
          0%, 100% {
            border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
            transform: translateX(-50%) translateY(0);
          }
          25% {
            border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
            transform: translateX(-50%) translateY(-10px);
          }
          50% {
            border-radius: 70% 30% 60% 40% / 40% 50% 60% 50%;
            transform: translateX(-50%) translateY(0);
          }
          75% {
            border-radius: 40% 60% 30% 70% / 30% 30% 60% 70%;
            transform: translateX(-50%) translateY(-5px);
          }
        }

        @keyframes floatUp {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-30px);
          }
        }

        @keyframes rotateSlow {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }

        @keyframes glowPulse {
          0%, 100% {
            box-shadow: 0 0 60px rgba(0, 255, 247, 0.6), 0 25px 50px -12px rgba(0, 0, 0, 0.5);
            filter: brightness(1);
          }
          50% {
            box-shadow: 0 0 90px rgba(0, 215, 255, 0.9), 0 25px 50px -12px rgba(0, 0, 0, 0.8);
            filter: brightness(1.15);
          }
        }

        @keyframes spinBorder {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }

        @keyframes imageZoomIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @media (max-width: 768px) {
          .image-wrapper {
            width: 350px;
            height: 300px;
            animation: slideInUp 1s ease-out;
          }

          .blob-large {
            width: 220px;
            height: 150px;
          }

          .profile-wrapper {
            margin-top: 0px;
          }

          .profile-ring {
            width: 250px;
            height: 250px;
          }

          .profile-image-container {
            width: 200px;
            height: 200px;
          }

          .border-animator {
            width: 215px;
            height: 215px;
          }

          .highlights {
            gap: 0.5rem;
            margin: 0.75rem 0;
          }

          .highlight-badge {
            font-size: 0.85rem;
          }

          .currently-working {
            padding: 1rem;
            margin: 1rem 0;
          }

          .currently-working li {
            font-size: 0.85rem;
          }

          .hero-content h1 {
            font-size: 2.5rem;
          }

          .hero-content h2 {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;